import request from '@/utils/request'

//活动类型列表
export function getType(params) {
  return request({
    url: '/api/activitynewtype/all',
    method: 'get',
    params
  });
}
//面向人群列表
export function getcrowd(params) {
  return request({
    url: '/api/activitynewcrowd/all',
    method: 'get',
    params
  });
}
//分页查询活动列表
export function getList(data) {
  return request({
    url: '/api/activitynew/list',
    method: 'post',
    data
  });
}
//分页查询培训班列表
export function getpxList(data) {
  return request({
    url: '/api/activitycultivate/list',
    method: 'post',
    data
  });
}
//特色展厅列表查询
export function getExhibitionAreaList(params) {
  return request({
    url: '/api/exhibitionAreaAppointment/getExhibitionAreaList',
    method: 'get',
    params
  });
}



//教育活动详情接口
export function getInfo(id) {
  return request({
    url: '/api/activitynew/info/'+id,
    method: 'get',
  });
}
//培训班详情接口
export function getpxInfo(id) {
  return request({
    url: '/api/activitycultivate/info/'+id,
    method: 'get',
  });
}

//热门展项详情接口
export function getExhibitionAreaDetail(params) {
  return request({
    url: '/api/exhibitionAreaAppointment/getExhibitionAreaDetail',
    method: 'get',
    params
  });
}
// 活动可预约日期
export function canAppointmentDate(params) {
  return request({
    url: '/api/activitynew/canAppointmentDate',
    method: 'get',
    params
  });
}
// 教育活动场次查询
export function findAppointmentTimeQuantum(params) {
  return request({
    url: '/api/activitynew/findAppointmentTimeQuantum',
    method: 'get',
    params
  });
}
// 培训班可预约日期
export function canAppointmentDatea(params) {
  return request({
    url: '/api/activitycultivate/canAppointmentDate',
    method: 'get',
    params
  });
}
// 培训班场次查询
export function findAppointmentTimeQuantuma(params) {
  return request({
    url: '/api/activitycultivate/findAppointmentTimeQuantum',
    method: 'get',
    params
  });
}
// 热门展项场次查询
export function getExhibitionAreaRoundList(params) {
  return request({
    url: '/api/exhibitionAreaAppointment/getExhibitionAreaRoundList',
    method: 'get',
    params
  });
}
//活动预约
export function appointment(data) {
  return request({
    url: '/api/activitynew/appointment',
    method: 'post',
    data
  });
}
//我的活动预约
export function myAppointmentPage(data) {
  return request({
    url: '/api/activitynew/myAppointmentPage',
    method: 'post',
    data
  });
}
//教育活动取消预约
export function cancelAppointmenta(params) {
  return request({
    url: '/api/activitynew/cancelAppointment',
    method: 'get',
    params
  });
}
//培训班取消预约
export function cancelAppointmentp(params) {
  return request({
    url: '/api/activitycultivate/cancelAppointment',
    method: 'get',
    params
  });
}
//热门展项取消预约
export function cancelApply(params) {
  return request({
    url: '/api/exhibitionAreaAppointment/cancelApply',
    method: 'get',
    params
  });
}
// 培训班类型列表--不分页
export function getTypeAll(params) {
  return request({
    url: '/api/activitycultivate/getTypeAll',
    method: 'get',
    params
  });
}
// 培训班面向人群列表--不分页
export function getCrowdAll(params) {
  return request({
    url: '/api/activitycultivate/getCrowdAll',
    method: 'get',
    params
  });
}
// 培训班确认订单，结算订单金额
export function confirmOrder(data) {
  return request({
    url: '/api/activitycultivate/confirmOrder',
    method: 'post',
    data
  });
}
// 培训班预约
export function appointmentpxb(data) {
  return request({
    url: '/api/activitycultivate/appointment',
    method: 'post',
    data
  });
}
// 提交预约
export function submitApply(data) {
  return request({
    url: '/api/exhibitionAreaAppointment/submitApply',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/activity/index.js